import {buildSalesPlanFormModel} from "@/services/transformers/salesPlanPayload";

const STORAGE_KEY = "sales_plans.duplicate_draft";

function getWindowStorage() {
  if (typeof window === "undefined") {
    return null;
  }

  return window.sessionStorage ?? null;
}

export function storeSalesPlanDuplicateDraft(model = {}) {
  const storage = getWindowStorage();
  if (!storage) {
    return null;
  }

  const payload = buildSalesPlanFormModel(model, model?.processing ?? null);

  try {
    storage.setItem(STORAGE_KEY, JSON.stringify(payload));
  } catch (error) {
    return null;
  }

  return payload;
}

export function clearSalesPlanDuplicateDraft() {
  const storage = getWindowStorage();
  if (!storage) {
    return false;
  }

  try {
    storage.removeItem(STORAGE_KEY);
    return true;
  } catch (error) {
    return false;
  }
}

export function consumeSalesPlanDuplicateDraft() {
  const storage = getWindowStorage();
  if (!storage) {
    return null;
  }

  let rawValue = null;

  try {
    rawValue = storage.getItem(STORAGE_KEY);
  } catch (error) {
    return null;
  }

  if (!rawValue) {
    return null;
  }

  try {
    return JSON.parse(rawValue);
  } catch (error) {
    return null;
  }
}
